<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">CONTENTS</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/praiseforrubysoames"><span class="toc-item-title-text">Praise for Ruby Soames</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/newslettersignup"><span class="toc-item-title-text">Newsletter sign-up</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter001"><span class="toc-item-title-text">Chapter 1</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/friday"><span class="toc-item-title-text">Friday</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter002"><span class="toc-item-title-text">Chapter 2</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/saturday" title="Link target outside of Sample"><span class="toc-item-title-text">Saturday</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter003"><span class="toc-item-title-text">Chapter 3</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/sunday" title="Link target outside of Sample"><span class="toc-item-title-text">Sunday</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter004"><span class="toc-item-title-text">Chapter 4</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/monday" title="Link target outside of Sample"><span class="toc-item-title-text">Monday</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter005"><span class="toc-item-title-text">Chapter 5</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/tuesday" title="Link target outside of Sample"><span class="toc-item-title-text">Tuesday</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter006"><span class="toc-item-title-text">Chapter 6</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/wednesday" title="Link target outside of Sample"><span class="toc-item-title-text">Wednesday</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter007"><span class="toc-item-title-text">Chapter 7</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/thursday" title="Link target outside of Sample"><span class="toc-item-title-text">Thursday</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/chapter008"><span class="toc-item-title-text">Chapter 8</span></a></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/newslettersignup2"><span class="toc-item-title-text">Newsletter sign-up</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/youwillalsoenjoy"><span class="toc-item-title-text">You will also enjoy:</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/acknowledgements" title="Link target outside of Sample"><span class="toc-item-title-text">Acknowledgements</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/abouttheauthor"><span class="toc-item-title-text">About the Author</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/anotefromthepublisher"><span class="toc-item-title-text">A note from the publisher</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b77d7b12